import { Vector3 } from 'three';
import Entity, { IEntity } from '../abstract/Entity';
import AttachmentModel, { AttachmentType } from './AttachmentModel'; // 1. Import AttachmentType
import AttributeModel from './AttributeModel'; // 2. Import AttributeModel

export interface IHotspot extends IEntity {
  id: number;
  position: Vector3;
}

class HotspotModel extends Entity implements IHotspot {
  id: number;

  position: Vector3;

  attachment: AttachmentModel;

  creationDate: Date;

  userId: string | null;

  constructor(
    id: number,
    position: Vector3,
    attachment: AttachmentModel = new AttachmentModel(
      AttachmentType.ATTRIBUTE, 
      new AttributeModel(-1, '') 
    ), 
    creationDate: Date = new Date(),
    userId: string | null = null
  ) {
    super();
    this.id = id;
    this.position = position;
    this.attachment = attachment;
    this.creationDate = creationDate;
    this.userId = userId;
  }

  getId() {
    return this.id;
  }

  setId(id: number) {
    this.id = id;
  }

  getPosition() {
    return this.position;
  }

  setPosition(position: Vector3) {
    this.position = position;
  }
}

export default HotspotModel;